/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/group.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getGroupData,
  createGroup,
  editGroup,
  getGroupInfo,
  deleteGroup
} from "@/service/groupService";
const group = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取group列表
     */
    getGroupData(store, info) {
      return new Promise((resolve, reject) => {
        getGroupData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建用户组
     * @param {*} store
     * @param {*} data
     */
    createGroup(store, data) {
      return new Promise((resolve, reject) => {
        createGroup(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取用户组详情
     * @param {*} store
     * @param {*} id
     */
    getGroupInfo(store, id) {
      return new Promise((resolve, reject) => {
        getGroupInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑用户组
     * @param {*} store
     * @param {*} data
     */
    editGroup(store, data) {
      return new Promise((resolve, reject) => {
        editGroup(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除用户组
     * @param {*} store
     * @param {*} id
     */
    deleteGroup(store, id) {
      return new Promise((resolve, reject) => {
        deleteGroup(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default group;



// WEBPACK FOOTER //
// ./src/store/modules/group.js